import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface GetCrmSnapshotStatusPayload {
  apiKey: string;
}

export interface GetCrmSnapshotStatusResponse {
  success: boolean;
  status: 'none' | 'generating' | 'ready' | 'error';
  snapshotId?: string;
  generatedAt?: number;
  contactCount?: number;
  eligibleCount?: number;
  downloadUrl?: string;
  error?: string;
}

async function getCrmSnapshotStatus(
  payload: GetCrmSnapshotStatusPayload,
  auth: Authentication
): Promise<GetCrmSnapshotStatusResponse> {
  try {
    return await HttpClient.get(
      `/integrations/contacts/snapshot/status?apiKey=${encodeURIComponent(payload.apiKey)}`,
      auth.token,
      { 'x-api-key': payload.apiKey },
    );
  } catch (e: any) {
    const errorMessage = e.message || 'Unknown error';
    throw new GetCrmSnapshotStatusFailure(errorMessage, 'snapshot-status-error');
  }
}

class GetCrmSnapshotStatusFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCrmSnapshotStatus;
